import { HashRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import Projects from "./pages/Projects";

function App() {
  return (
    <Router>

      {/* 🔹 ADD NAVBAR HERE */}
      <nav style={{ textAlign: "center", padding: "15px", background: "#222" }}>
        <Link to="/" style={{ color: "white", margin: "10px" }}>Home</Link>
        <Link to="/projects" style={{ color: "white", margin: "10px" }}>Projects</Link>
      </nav>

      {/* 🔹 ROUTES */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
      </Routes>

    </Router>
  );
}

export default App;